import axios from 'axios';
import errorMessage from 'Store/actions/errorMessage';
import { apiURLMapping } from 'Pages/ChanceGames/cgUtils';
import {
  GET_CHANCE_GAMES_RULES_REQUEST,
  GET_CHANCE_GAMES_RULES_SUCCESS,
  GET_CHANCE_GAMES_RULES_FAILURE,
  SET_CHANGE_GAMES_DEFAULT_COLUMNS
} from 'Store/constants';
import { gameTypeConverter } from 'Store/constants/sportTypes';
import ProjectConfig from 'ProjectConfig';
const API_GATEWAY = ProjectConfig.API_GATEWAY;

export const getCGRules = gameType => async (dispatch, getState) => {
  try {
    dispatch({
      type: GET_CHANCE_GAMES_RULES_REQUEST
    });

    const res = await axios.get(`${API_GATEWAY}/mobile/digital-lottery/rules?gameType=${apiURLMapping[gameType]}`);

    const data = {
      startNumber: res.data.startNumber,
      endNumber: res.data.endNumber,
      maxDigitForColumn: res.data.maxGuessCountForColumn,
      maxColumnCount: res.data.maxColumnCount,
      maxCouponCount: res.data.maxCouponCount,
      extra: {
        extraStartNumber: res.data.optionalStartNumber,
        extraEndNumber: res.data.optionalEndNumber,
        maxDigitForColumn: res.data.optionalMaxGuessCount
      }
    };

    dispatch({
      type: GET_CHANCE_GAMES_RULES_SUCCESS,
      payload: data
    });

    const currentGameObj = getState().chanceGames.cgPlay[gameTypeConverter[gameType]];

    if (currentGameObj && !currentGameObj.selections) {
      dispatch({
        type: SET_CHANGE_GAMES_DEFAULT_COLUMNS,
        payload: { gameType, maxColumnCount: res.data.maxColumnCount * res.data.maxCouponCount }
      });
    }
  } catch (e) {
    dispatch({
      type: GET_CHANCE_GAMES_RULES_FAILURE,
      payload: e.response && e.response.data || errorMessage,
    });
  }
};
